import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'atx-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageNotFoundComponent {
  @Input()
  public iconName: string[] | string = 'ghost';

  @Input()
  public header = $localize`:UI|Not found header@@uiNotFoundHeader:Oops, something went wrong`;

  @Input()
  public message = $localize`:UI|Not found message@@uiNotFoundMessage:We couldn't get the content you are looking for at the moment. Please try again later.`;
}
